<div class="row" *ngIf="isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">


                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Transilagem Data</mat-label>
                                <input matInput id="txtIniTransData" #txtIniTransData maxlength="10" mask="d0/M0/0000"
                                    formControlName="Inicio_transilagem_data" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtIniTransData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_transilagem_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Transilagem Hora</mat-label>
                                <input matInput id="txtIniTransHora" #txtIniTransHora maxlength="5" mask="Hh:m0"
                                    formControlName="Inicio_transilagem_hora" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtIniTransHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_transilagem_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Silo Destino Transilagem</mat-label>
                                <input matInput id="txtSiloDestTrans" #txtSiloDestTrans maxlength="20"
                                    formControlName="Silo_destino_transilagem" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtSiloDestTrans.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Silo_destino_transilagem)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Motivo</mat-label>
                                <mat-select #txtCheckSapQuim formControlName="Motivo" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterMotivo($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsMotivo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Motivo)}}</mat-error>
                                <!-- <input matInput id="txtMotv" #txtMotv maxlength="80" formControlName="Motivo">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start"></mat-hint>
                                <mat-hint align="end">{{txtMotv.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Motivo)}}
                                </mat-error> -->
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Retirada Armazem Data</mat-label>
                                <input matInput id="txtIniRetArmData" #txtIniRetArmData maxlength="10" mask="d0/M0/0000"
                                    formControlName="Inicio_retirada_armazem_data" (blur)="makeCalculations()"
                                    (blur)="calcArmazemDias()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtIniRetArmData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_retirada_armazem_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Retirada Armazem Hora</mat-label>
                                <input matInput id="txtIniRetArmHora" #txtIniRetArmHora maxlength="5" mask="Hh:m0"
                                    formControlName="Inicio_retirada_armazem_hora" (blur)="makeCalculations()"
                                    (blur)="calcArmazemDias()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtIniRetArmHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_retirada_armazem_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Retorno Silo Data</mat-label>
                                <input matInput id="txtIniRetSiloData" #txtIniRetSiloData maxlength="10"
                                    mask="d0/M0/0000" formControlName="Inicio_retorno_silo_data"
                                    (blur)="makeCalculations()" (blur)="calcArmazemDias()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtIniRetSiloData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_retorno_silo_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Retorno Silo Hora</mat-label>
                                <input matInput id="txtIniRetSiloHora" #txtIniRetSiloHora maxlength="5" mask="Hh:m0"
                                    formControlName="Inicio_retorno_silo_hora" (blur)="makeCalculations()"
                                    (blur)="calcArmazemDias()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtIniRetSiloHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_retorno_silo_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Silo Destino Retorno</mat-label>
                                <input matInput id="txtSiloDestRet" #txtSiloDestRet maxlength="20"
                                    formControlName="Silo_destino_retorno" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtSiloDestRet.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Silo_destino_retorno)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Local Atual</mat-label>
                                <input matInput id="txtLocalAtual" #txtLocalAtual maxlength="10"
                                    formControlName="Local_atual" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtLocalAtual.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Local_atual)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Decarga Silo Data</mat-label>
                                <input matInput id="txtIniDescSiloData" #txtIniDescSiloData maxlength="10"
                                    mask="d0/M0/0000" formControlName="Inicio_descarga_silo_data"
                                    (blur)="makeCalculations()" (blur)="calcArmazemDias()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtIniDescSiloData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_descarga_silo_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Decarga Silo Hora</mat-label>
                                <input matInput id="txtIniDescSiloHora" #txtIniDescSiloHora maxlength="5" mask="Hh:m0"
                                    formControlName="Inicio_descarga_silo_hora" (blur)="makeCalculations()"
                                    (blur)="calcArmazemDias()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtIniDescSiloHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_descarga_silo_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Destino DS Final</mat-label>
                                <mat-select #txtDestinoDsFinal formControlName="Destino_ds_final"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterDestino($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsDestino" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <!-- <input matInput id="txtDestinoDs" #txtDestinoDs maxlength="40"
                                    formControlName="Destino_ds_final" [matAutocomplete]="auto17">
                                <mat-autocomplete #auto17="matAutocomplete">
                                    <mat-option *ngFor="let item of filterOptionsDestinoDs | async" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <!-- <mat-hint align="end">{{txtDestinoDs.value.length}} / 40</mat-hint> -->
                                <mat-error>{{hasErrorFormControl(formulario.controls.Destino_ds_final)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Armazenagem (dias)</mat-label>
                                <input matInput id="txtArmaz" #txtArmaz maxlength="20"
                                    formControlName="Armazenagem_dias" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtArmaz.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Armazenagem_dias)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
